<template>
  <Product />
</template>
<script>
import Product from "@/components/Product.vue";
export default {
  components: {
    Product
  },
  name: "Search",
  data() {
    return {

    };
  },
  methods: {
 
  },
};
</script>
